export default __webpack_public_path__ + "landingPageIWPR_LogedIn.html";